<template>
  <div class="edit-box">
    <div class="input-box editor-box">
      <span class="title">{{this.title}}</span>
      <input :placeholder="tips" v-model="editValue" class="input" />
    </div>
    <p v-if="msg" class="msg">{{msg}}</p>
  </div>
</template>

<script>
import editor from "../../mixins/editor";
export default {
  mixins: [editor]
};
</script>

